/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('chapterslistitem', function () {
        return {
            scope: {
                collectionNodeItem: '=',
                sectionIndex: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/chapterslistitem/chapterslistitem.view.html',
            controller: ["$scope", "DocumentService", function ($scope, DocumentService) {
                var scope = $scope;

                //$scope.pageNumber = 2;
                $scope.scrollToSection = function(){
                    if (!scope.collectionNodeItem.items) {
                        DocumentService.scrollDocumentToChapter(scope.collectionNodeItem.url);
                    }
                }
            }]
        };
    });